import DOMPurify from "dompurify";
import { marked } from "marked";

// Render LLM-generated brief markdown safely. XSS defense (red-team finding #7):
//   1. Parse markdown -> HTML with `marked`.
//   2. Sanitize the RESULTING HTML with a pinned DOMPurify profile (NOT the source string).
// The pipeline validator also forbids raw HTML in brief_vi, but the frontend does not trust that.
const PROFILE = {
  ALLOWED_TAGS: ["p", "ul", "ol", "li", "strong", "em", "h3", "h4", "blockquote", "br", "a", "code"],
  ALLOWED_ATTR: ["href"],
  ALLOWED_URI_REGEXP: /^https?:/i,
};

export function renderBriefMarkdown(md: string): string {
  const html = marked.parse(md, { async: false }) as string;
  return DOMPurify.sanitize(html, PROFILE);
}
